var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{attrs:{"id":"icon"}},[_c('img',{attrs:{"src":require("@/assets/images/icons/icon_welfare.png"),"alt":"Bijstand"}})]),_c('h3',{attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }